import React, { useEffect, useState } from "react";
import { Play, Video, Image as ImageIcon, X } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { fetchMedia } from "../lib/api";

const TABS = [
  { slug: "all", label: "Tout" },
  { slug: "backstage", label: "Coulisses" },
  { slug: "product", label: "Nos parfums" },
  { slug: "packaging", label: "Emballage" },
  { slug: "shipping", label: "Expédition" },
  { slug: "founder", label: "La Maison" },
];

const Gallery = () => {
  const [media, setMedia] = useState([]);
  const [tab, setTab] = useState("all");
  const [open, setOpen] = useState(null);

  useEffect(() => { fetchMedia().then(setMedia).catch(() => {}); }, []);
  const filtered = tab === "all" ? media : media.filter((m) => m.category === tab);

  return (
    <div className="bg-[#050505] min-h-screen">
      <Navbar />
      <div className="pt-40 pb-24 max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="mb-14 max-w-3xl reveal">
          <p className="label-caps text-[color:var(--gold)] mb-6">Galerie · Contenus authentiques</p>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-7xl text-white leading-[0.95]">
            L'envers du <em className="italic text-[color:var(--gold-soft)]">décor</em>.
          </h1>
          <p className="text-white/60 font-light mt-8 max-w-xl leading-relaxed">
            Découvrez nos parfums en vidéo, le soin apporté à chaque commande, nos ateliers et l'équipe qui donne vie à MAISON DOUBA.
          </p>
        </div>

        <div className="flex flex-wrap gap-3 mb-14 label-caps text-[10px]">
          {TABS.map(t => (
            <button key={t.slug} onClick={() => setTab(t.slug)} className={`px-4 py-2 border transition-colors ${tab === t.slug ? "border-[color:var(--gold)] text-[color:var(--gold)]" : "border-white/15 text-white/60 hover:border-white/30"}`}>{t.label}</button>
          ))}
        </div>

        {filtered.length === 0 ? (
          <p className="text-white/40 italic text-center py-24">Bientôt de nouveaux contenus.</p>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
            {filtered.map((m) => (
              <button
                key={m.id}
                onClick={() => setOpen(m)}
                className="group relative aspect-[3/4] bg-[#0a0a0a] overflow-hidden reveal"
                data-testid={`gallery-item-${m.id.slice(0, 8)}`}
              >
                {m.media_type === "video" ? (
                  <video src={m.media_url} className="w-full h-full object-cover product-image" muted playsInline preload="metadata" />
                ) : (
                  <img src={m.media_url} alt={m.title} className="w-full h-full object-cover product-image" />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
                {m.media_type === "video" && (
                  <div className="absolute inset-0 flex items-center justify-center opacity-90 group-hover:opacity-100 transition-opacity">
                    <div className="w-14 h-14 rounded-full bg-[color:var(--gold)]/90 flex items-center justify-center">
                      <Play size={20} className="text-black ml-1" fill="currentColor" />
                    </div>
                  </div>
                )}
                <div className="absolute bottom-4 left-4 right-4 text-left">
                  <p className="label-caps text-[color:var(--gold)] text-[9px] mb-1">{m.media_type === "video" ? "Vidéo" : "Photo"}</p>
                  <p className="font-serif text-white text-sm md:text-base leading-tight">{m.title}</p>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>

      {open && (
        <div className="fixed inset-0 z-[80] bg-black/95 flex items-center justify-center p-4" onClick={() => setOpen(null)}>
          <button onClick={() => setOpen(null)} className="absolute top-6 right-6 text-white/70 hover:text-white z-10"><X size={24} /></button>
          <div className="max-w-4xl w-full" onClick={(e) => e.stopPropagation()}>
            {open.media_type === "video" ? (
              <video src={open.media_url} controls autoPlay className="w-full max-h-[80vh]" />
            ) : (
              <img src={open.media_url} alt={open.title} className="w-full max-h-[80vh] object-contain" />
            )}
            <div className="mt-6 text-center">
              <p className="label-caps text-[color:var(--gold)] mb-2 text-[10px]">{TABS.find(t => t.slug === open.category)?.label}</p>
              <h3 className="font-serif text-3xl text-white">{open.title}</h3>
              {open.description && <p className="text-white/60 mt-3 font-light max-w-xl mx-auto">{open.description}</p>}
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Gallery;
